import React, { useState } from "react";
import { Dialog } from "@mui/material";
import UserTypeSelection from "../Feature/admin/userManagement/userComponent/UserTypeSelection";
import ServiceOfferedForm from "../Feature/admin/userManagement/userComponent/serviceOfferedForm";
import DeleteConfirmation from "./deleteConfirmation";
import OrderView from "../Feature/bussiness/components/orderView";
import CustomerView from "../Feature/bussiness/components/customerView";
import PricingTierForm from "../Feature/bussiness/components/priceingTierForm";
import AddNote from "../Feature/admin/userManagement/userComponent/addNote";
import SessionTimeout from "./sessionTimeout";
import ApproveRejectForm from "../Feature/admin/approvalDashboard/ApproveRejectForm";
import InventoryForm from "../Feature/bussiness/components/inventoryForm";
import ServicesSettigs from "../Feature/admin/serviceSettings/addSettings";
import AddressForm from "./addressForm";
import ViewAll from "../Feature/admin/serviceSettings/viewAll";
import Alert from "../Feature/customer/components/alertMessage";
import AssignRoleForm from "./rbacManagement/assignRoleForm";
import CreateEmployee from "./rbacManagement/createEmployee";
import CreatePermission from "./rbacManagement/createPermission";
import CreateRole from "./rbacManagement/createRole";
import RatingsReviews from "../Feature/customer/components/review";
import FeedbackView from "../Feature/deliveryPartner/components/feedbackView";
import MissMatchOrder from "../Feature/bussiness/operationalSetting/orderManagement/missMatchOrder";
import ServiceSelection from "../Feature/customer/home/serviceSelection";
import Discount from "../Feature/customer/placeOrder/reviewAndPlaceOrder/discount";
import LogoutConfirmation from "./logoutConfirmation";
import CreateBroadcast from "../Feature/admin/broadcast/createBroadcast";
import PaymentConfirmation from "../Feature/admin/payment&Payout/paymentConfirmation";
import ManualPayoutStatus from "../Feature/admin/payment&Payout/manualPayoutStatus";
import ConfirmPayment from "../Feature/customer/placeOrder/reviewAndPlaceOrder/confirmPayment";

const CustomPopupForm = ({
  dialogType,
  handleClose,
  isOpen,
  userHandler,
  dialogDetails,
  mode,
  onDelete,
  onSubmit,
  type,
  showMismatchReport = true,
}) => {
  const getDialogProps = () => {
    switch (dialogType) {
      case "user-type-selection":
        return {
          maxWidth: false,
          width: 700,
        };
      case "service-offered":
        return {
          maxWidth: "md",
        };
      case "create-employee":
        return {
          maxWidth: "md",
        };
      case "create-permission":
        return {
          maxWidth: "sm",
        };
      case "create-role":
        return {
          maxWidth: "sm",
        };
      case "assign-role":
        return {
          maxWidth: "md",
        };
      case "approve-reject":
        return {
          maxWidth: "md",
        };
      case "delete":
        return {
          maxWidth: "sm",
        };
      case "order-view":
        return {
          maxWidth: false,
          width: 500,
        };
           case "discount":
        return {
          maxWidth: false,
          width: 500,
        };
      case "customer-view":
        return {
          maxWidth: false,
          width: 400,
        };
      case "pricing-tier":
        return {
          maxWidth: "sm",
        };
      case "add-note":
        return {
          maxWidth: false,
          width: 500,
        };
      case "session-timeout":
        return {
          maxWidth: "sm",
        };
       case "logout":
          return {
          maxWidth: false,
          width: 400,
        };
      case "inventory":
         return {
          maxWidth: "md",
        };
      case "service-settings":
        return {
          maxWidth: false,
          width: 500,
        };
      case "address":
        return {
          maxWidth: false,
          width: 600,
        };
      case "view-all":
        return {
          maxWidth: false,
          width: 600,
        };

      case "alert":
        return {
          maxWidth: false,
          width: 600,
        };
      case "review":
        return {
          maxWidth: false,
          width: 600,
        };
      case "review-feedback":
        return {
          maxWidth: false,
          width: 600,
        };
         case "miss-match-order":
        return {
          maxWidth: false,
          width: 600,
        };

        case "service-selection":
       return {
          maxWidth: "sm",
        };

         case "broadcast":
        return {
          maxWidth: false,
          width: 500,
        };

        
         case "Payout":
        return {
          maxWidth: false,
          width: 500,
        };

         case "Manual-payout-status":
        return {
          maxWidth: false,
          width: 500,
        };

          case "tip":
        return {
          maxWidth: false,
          width: 400,
        };

      default:
        return "lg";
    }
  };

  const openCustomDialog = () => {
    switch (dialogType) {
      case "user-type-selection":
        return (
          <div>
            <UserTypeSelection onClose={handleClose} handleUser={userHandler} />
          </div>
        );

         case "logout":
        return (
          <div>
            <LogoutConfirmation onClose={handleClose}  />
          </div>
        );


      case "service-offered":
        return (
          <div>
            <ServiceOfferedForm
              onClose={handleClose}
              onSubmit={onSubmit}
              dialogDetails={dialogDetails}
            />
          </div>
        );

      case "create-employee":
        return (
          <div>
            <CreateEmployee
              onClose={handleClose}
              mode={mode}
              employeeDetails={dialogDetails}
              onSubmit={onSubmit}
            />
          </div>
        );
      case "create-permission":
        return (
          <div>
            <CreatePermission
              onClose={handleClose}
              mode={mode}
              permissionDetails={dialogDetails}
              onSubmit={onSubmit}
            />
          </div>
        );
      case "create-role":
        return (
          <div>
            <CreateRole
              onClose={handleClose}
              onSubmit={onSubmit}
              dialogDetails={dialogDetails}
            />
          </div>
        );
      case "assign-role":
        return (
          <div>
            <AssignRoleForm
              onClose={handleClose}
              roleDetails={dialogDetails}
              onSubmit={onSubmit}
            />
          </div>
        );
      case "approve-reject":
        return (
          <div>
            <ApproveRejectForm
              onClose={handleClose}
              approvalDetails={dialogDetails}
              onSubmit={onSubmit}
            />
          </div>
        );
      case "delete":
        return (
          <div>
            <DeleteConfirmation
              onClose={handleClose}
              handleDelete={onDelete}
              dialogDetails={dialogDetails}
              type={type}
            />
          </div>
        );
      case "alert":
        return (
          <div>
            <Alert
              onClose={handleClose}
              dialogDetails={dialogDetails}
              onSubmit={onSubmit}
            />
          </div>
        );

      case "order-view":
        return (
          <div>
            <OrderView onClose={handleClose}
             dialogDetails={dialogDetails} 
              onSubmit={onSubmit}
              showMismatchReport={showMismatchReport}
             />
          </div>
        );
      case "miss-match-order":
       return (
          <div>
            <MissMatchOrder
             onClose={handleClose}
             dialogDetails={dialogDetails} 
              onSubmit={onSubmit}
             />
          </div>
        );

           case "broadcast":
       return (
          <div>
            <CreateBroadcast
             onClose={handleClose}
             onSubmit={onSubmit}
             />
          </div>
        );
      case "customer-view":
        return (
          <div>
            <CustomerView onClose={handleClose} dialogDetails={dialogDetails} />
          </div>
        );
         case "discount":
        return (
          <div>
            <Discount onClose={handleClose} dialogDetails={dialogDetails} onSubmit={onSubmit} />
          </div>
        );
      case "pricing-tier":
        return (
          <div>
            <PricingTierForm
              onClose={handleClose}
              dialogDetails={dialogDetails}
              onSubmit={onSubmit}
              mode={mode}
            />
          </div>
        );
      case "add-note":
        return (
          <div>
            <AddNote
              onClose={handleClose}
              dialogDetails={dialogDetails}
              onSubmit={onSubmit}
            />
          </div>
        );
      case "session-timeout":
        return (
          <div>
            <SessionTimeout onClose={handleClose} />
          </div>
        );
      case "inventory":
        return (
          <div>
            <InventoryForm
              onClose={handleClose}
              onSubmit={onSubmit}
              dialogDetails={dialogDetails}
              mode={mode}
            />
          </div>
        );
      case "service-settings":
        return (
          <div>
            <ServicesSettigs onClose={handleClose} onSubmit={onSubmit} />
          </div>
        );
      case "address":
        return (
          <div>
            <AddressForm
              onClose={handleClose}
              mode={mode}
              addressDetails={dialogDetails}
              onSubmit={onSubmit}
            />
          </div>
        );
      case "view-all":
        return (
          <div>
            <ViewAll
              onClose={handleClose}
              dialogDetails={dialogDetails}
              onDelete={onDelete}
            />
          </div>
        );

      case "review":
        return (
          <div>
            <RatingsReviews
              onClose={handleClose}
              mode={mode}
              reviewDetails={dialogDetails}
              onSubmit={onSubmit}
            />
          </div>
        );

      case "review-feedback":
        return (
          <div>
            <FeedbackView
              onClose={handleClose}
              mode={mode}
              reviewDetails={dialogDetails}
              onSubmit={onSubmit}
            />
          </div>
        );

           case "service-selection":
        return (
          <div>
            <ServiceSelection onClose={handleClose} onSubmit={onSubmit} dialogDetails={dialogDetails}/>
          </div>
        );

           case "Payout":
        return (
          <div>
            <PaymentConfirmation onClose={handleClose} onSubmit={onSubmit} dialogDetails={dialogDetails}/>
          </div>
        );

           case "Manual-payout-status":
        return (
          <div>
            <ManualPayoutStatus
              onClose={handleClose}
              onSubmit={onSubmit}
              dialogDetails={dialogDetails}
            />
          </div>
        );

        
           case "tip":
        return (
          <div>
            <ConfirmPayment onClose={handleClose} orderTotal={dialogDetails} onPay={onSubmit} />
          </div>
        );

      default:
        return null;
    }
  };
  const dialogProps = getDialogProps();
  return (
    <Dialog
      fullWidth={dialogProps.maxWidth !== false}
      maxWidth={dialogProps.maxWidth || false}
      open={isOpen}
      onClose={handleClose}
      PaperProps={{
    sx: {
      borderRadius: "16px",
      ...(dialogProps.width ? { width: dialogProps.width } : {}),
    },
  }}
    >
      {openCustomDialog()}
    </Dialog>
  );
};

export default CustomPopupForm;
